import React from "react";

const DashboardIcon = () => (
  <svg className="dashboard-icon" x="0px" y="0px" viewBox="0 0 21 21">
    <g
      id="Group_261"
      data-name="Group 261"
      transform="translate(-1038.19 -190.372)"
    >
      <g
        id="Rectangle_58"
        data-name="Rectangle 58"
        transform="translate(1038.19 190.372)"
        fill="none"
        stroke="inherit"
        strokeWidth="1.1"
      >
        <rect width="9" height="8" rx="2" stroke="none" />
        <rect x="0.7" y="0.7" width="7.6" height="6.6" rx="1.3" fill="none" />
      </g>
      <g
        id="Rectangle_60"
        data-name="Rectangle 60"
        transform="translate(1050.19 203.372)"
        fill="none"
        stroke="inherit"
        strokeWidth="1.1"
      >
        <rect width="9" height="8" rx="2" stroke="none" />
        <rect x="0.7" y="0.7" width="7.6" height="6.6" rx="1.3" fill="none" />
      </g>
      <g
        id="Rectangle_59"
        data-name="Rectangle 59"
        transform="translate(1038.19 200.372)"
        fill="none"
        stroke="inherit"
        strokeWidth="1.1"
      >
        <rect width="9" height="11" rx="2" stroke="none" />
        <rect x="0.7" y="0.7" width="7.6" height="9.6" rx="1.3" fill="none" />
      </g>
      <g
        id="Rectangle_61"
        data-name="Rectangle 61"
        transform="translate(1050.19 190.372)"
        fill="none"
        stroke="inherit"
        strokeWidth="1.1"
      >
        <rect width="9" height="11" rx="2" stroke="none" />
        <rect x="0.7" y="0.7" width="7.6" height="9.6" rx="1.3" fill="none" />
      </g>
    </g>
  </svg>
);

export default DashboardIcon;
